var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center space-x-2 select-none"},[_c('input',{attrs:{"id":"strict","type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('label',{attrs:{"for":"strict"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }